<template>
	<div style="padding: 1%;">
		<apexchart dark type=bar height=400 :options="chartOptions" :series="series" />
	</div>
</template>

<script>
import apexchart from 'vue-apexcharts'

export default {
	components: {
		apexchart
	},
	data: function() {
		return {
			series: [{
				name: this.textYAxes,
				data: this.values[1] != undefined ? this.values[1] : [0]
			}],
			chartOptions: {
				colors: ['#10303D'],
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: '50%',
					},
				},
				dataLabels: {
					enabled: false,
				},
				stroke: {
					show: true,
					width: 1,
					colors: ['transparent']
				},
				xaxis: {
					type: 'category',
					title: {
						text: 'Dias alojados',
						style: {
							color: '#000000de'
						},
					},
					tickAmount: this.size == 'xs' ? 4 : this.size == 'sm' ? 9 : this.size == 'md' ? 14 : 24,
					// categories: this.values[0] != undefined ? this.values[0] : [0],
					labels: {
						style: {
							colors: '#000000de'
						},
						formatter: function (val) {
							return (val * 7).toFixed(0)
						}
					}
				},
				yaxis: {
					title: {
						text: 'Quantidade',
						style: {
							color: '#000000de'
						}
					},
					labels: {
						style: {
							color: '#000000de'
						},
						formatter: function (val) {
							return val
						}
					}
				},
				fill: {
					opacity: 1
				},
				tooltip: {
					style: {
						fontSize: '14px',
						fontFamily: undefined
					},
					y: {
						formatter: function (val) {
							return val
						}
					},
					x: {
						formatter: function (val) {
							return 'Dias alojados: ' + (val * 7).toFixed(0)
						}
					}
				},
				legend: {
					position: 'top',
					horizontalAlign: 'center',
					fontSize: '14px',
					labels: {
						colors: '#000000de',
						useSeriesColors: false
					},
				},
			}
		}
	},
	computed: {
	},
	props: {
		values: Array,
		textYAxes: {
			type: String,
			default: ''
		},
		size: String
	}
}

</script>

<style>
	.apexcharts-menu.open {
		color: black;
	}
	.apexcharts-tooltip {
		background: #f3f3f3;
		color: black;
	}
</style>

